import React from "react";
import FormRow from "components/Form/FormRow";
import FormInput from "components/Form/FormInput";

const mapInputs = (inputItem, formContext, experimentVariation) => {
  const reducedInputs = inputItem.filter((input) =>
    (input.variation && experimentVariation ? getIsFieldVariant(input, experimentVariation) : true));

  const getFormInputKey = (input, i) => {
    if (input.type === "radio") {
      return input.value;
    }

    if (input.type === "checkbox" && input.id) {
      return input.id;
    }

    return input.name ?? `form-input_${i}`;
  };

  return reducedInputs.map((input, i) => (
    <FormInput
      onUpdate={input.onUpdate}
      classes={input.classes}
      defaultValue={input.defaultValue}
      defaultOption={input.defaultOption}
      disabled={input.disabled}
      errors={input.errors}
      id={input.id}
      key={getFormInputKey(input, i)}
      label={input.label}
      name={input.name}
      options={input.options}
      placeholder={input.placeholder}
      required={input.required}
      type={input.type}
      subtext={input.subtext}
      value={input.value}
      loadingMessage={input.loadingMessage}
      formContext={formContext}
      dataTestId={input.dataTestId}
      toolbar={input.toolbar}
    />
  ));
};

export function FormBuilder(formContent, methods, experimentVariation) {
  const {
    formState: { isValid, isSubmitting, isSubmitSuccessful },
  } = methods;
  const formContext = {
    isValid,
    isSubmitting,
    isSubmitSuccessful,
  };

  if (formContent instanceof Array) {
    return formContent.map((inputRow, i) => {
      const inputChildren = inputRow.fields ? mapInputs(inputRow.fields, formContext, experimentVariation) : [];
      const title = inputRow.title ?? null;
      const classes = inputRow.classes ?? null;

      return (
        <FormRow
          classes={classes}
          children={inputChildren}
          methods={methods}
          title={title}
          key={`input-row_${i}`}
        />
      );
    });
  }
}

const getIsFieldVariant = (inputItem, experimentVariation) => {
  if (inputItem.variation !== experimentVariation) {
    return false;
  }
  return true;
};
